import { NavItems } from '@shared/Frontend/components/navItems'
import { AsyncState, Maybe } from 'ballerina-core'

export type CMSMenuState = AsyncState<Maybe<NavItems>>

export const initialCMSMenuState: CMSMenuState = AsyncState.Default.unloaded()
